import React from "react";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Link as MuiLink,
  Divider,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { employeeAudit } from "../../ReferenceManagement/reference.config";

const People = () => {
  return (
    <Box>
      <Card>
        <CardHeader
          sx={{
            backgroundColor: "#f8f9fa", // adjust to your theme's header color
            pb: 0,
          }}
          title={
            <Typography
              variant="h6"
              component="p"
              sx={{
                color: "primary.main",
                fontWeight: 700,
                py: 1.5,
                borderBottom: "1px solid",
                borderColor: "divider",
                mb: 0,
              }}
            >
              Employee Audit Reports
            </Typography>
          }
        />
        <CardContent sx={{ pt: 1 }}>
          <Box>
            {employeeAudit.map((item) => (
              <Box
                key={item.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid",
                  borderColor: "divider",
                  p: 0.5,
                  mb: 0.5,
                  borderRadius: 0.5,
                }}
              >
                <MuiLink
                  component={RouterLink}
                  to="#"
                  sx={{
                    mr: 1.5,
                    display: "block",
                    textDecoration: "none",
                  }}
                >
                  {item.name}
                </MuiLink>
                <Typography
                  component="span"
                  sx={{ py: 0.5, display: "block" }}
                >
                  {item.title}
                </Typography>
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default People;